export default class Path {
    public static join(...parts: string[]): string {
        const schemeMatch: RegExpMatchArray | null = parts[0].match(/^[^\/]+\/\//);
        let schemePart: string = '';

        if (schemeMatch) {
            schemePart = schemeMatch[0];
            parts[0] = parts[0].substr(schemePart.length);
        }

        const path: string = parts
            .map((part: string) => {
                return part
                    .replace(/\/{2,}/g, '/')
                    .replace(/^\/(.*)/, '$1')
                    .replace(/(.*)\/$/, '$1');
            })
            .join('/');

        return schemePart + path;
    }

    public static route(routeString: string, params: any = {}, query: any = {}): string {
        Object.entries(params).forEach(([key, value]: [string, any]) => {
            routeString = routeString.replace(`{${key}}`, `${value}`);
        });
        // Remove optional params.
        routeString = routeString.replace(/\[[^\]]+\]/, '');
        let queryString: string = '';

        Object.entries(query).forEach(([key, value]: [string, any]) => {
            queryString += `${key}=${encodeURIComponent(value)}&`;
        });

        if (queryString) {
            routeString += '?' + queryString.slice(0, -1);
        }

        return routeString;
    }
}
